import { render, staticRenderFns } from "./NutritionBatchAddModal.vue?vue&type=template&id=a1ad1158&scoped=true"
import script from "./NutritionBatchAddModal.vue?vue&type=script&lang=js"
export * from "./NutritionBatchAddModal.vue?vue&type=script&lang=js"
import style0 from "./NutritionBatchAddModal.vue?vue&type=style&index=0&id=a1ad1158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ad1158",
  null
  
)

export default component.exports